import axios from "axios";
import { API_URL } from "configs";
export const PARETO_CHART_REQUEST = "PARETO_CHART_REQUEST";
export const PARETO_CHART_VALIDATION_ERROR = "PARETO_CHART_VALIDATION_ERROR";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";

export const PARETO_CHART_SUMMARY_SUCCESS = "PARETO_CHART_SUMMARY_SUCCESS";

const showCommonLoader = (label = "") => ({
  type: SHOW_LOADER,
  common_loder_label: label,
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
});

const paretoChartRequest = () => ({
  type: PARETO_CHART_REQUEST,
});

const paretoChartFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});

const validationError = (notification) => ({
  type: PARETO_CHART_VALIDATION_ERROR,
  validation_error: notification,
});
const tokenError = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "token_expire",
});

const paretoChartSummarySuccess = (paretoChartSummary) => ({
  type: PARETO_CHART_SUMMARY_SUCCESS,
  paretoChartSummary: paretoChartSummary,
});

// export const paretoChartSummaryFetch = () => {
//   var token = localStorage.getItem("token");

//   return dispatch => {
//     console.log('124');
//     dispatch(showCommonLoader());
//     dispatch(paretoChartRequest());

//     return axios(API_URL + "pareto_chart/getParetoChart", {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//         Authorization: "Bearer " + token,
//       },
//     }).then(
//       (response) => {
//         dispatch(paretoChartSummarySuccess(response));
//         dispatch(hideCommonLoader());
//       },
//       (error) => {
//         handleErrorResponse(error, dispatch);
//         dispatch(hideCommonLoader());
//       }
//     );
//   };
// };

export const paretoChartSummaryFetch = (filters) => {
  var token = localStorage.getItem("token");
  return dispatch => {
    dispatch(showCommonLoader());
    dispatch(paretoChartRequest());

    return axios(API_URL + "pareto_chart/getParetoChart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: filters,
    })
      .then((response) => {
     
        dispatch(paretoChartSummarySuccess(response.data));
        dispatch(hideCommonLoader());
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      });
  };
};


// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(paretoChartFailure(err));
    }
  } catch (e) {
    dispatch(
      paretoChartFailure("Unable to perform action.Something went wrong")
    );
  }
};
